export default __webpack_public_path__ + "static/transaction-notifications-v2-7923f21a225134878b342de8672a9d18.png";